export const getEllipsisText = (
  str: string,
  len: number, // count the number of characters to display including the ellipsis, pass a negative number to display the whole string
) => {
  const trimmedStr = str.trim()
  if (len <= 0) return str
  if (trimmedStr.length <= len + 3) return trimmedStr // 3 is for the ellipsis
  return trimmedStr.slice(0, len).trim() + '...'
}
